module.exports = __webpack_public_path__ + "static/media/emptystate.faa7fd24.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/practice/emptystate.png
// module id = 115
// module chunks = 0